import { useEffect } from 'react';

/**
 * A `application/ld+json` block, removed again when the route changes so a
 * story's markup never lingers on the page someone navigates to next.
 */
export default function JsonLd({ id, data }: { id: string; data: object | object[] }) {
    const serialised = JSON.stringify(data);

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.dataset.jsonld = id;
        // `<` cannot appear raw inside a script element.
        script.textContent = serialised.replace(/</g, '\\u003c');
        document.head.querySelector(`script[data-jsonld="${id}"]`)?.remove();
        document.head.appendChild(script);
        return () => script.remove();
    }, [id, serialised]);

    return null;
}
